// extracted by mini-css-extract-plugin
export default {"criterias_container":"style_criterias_container__p34Ya"};